import React, { useState } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import { Markup } from 'interweave';



export default function ModalView(props) {
    
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
    }

    const handleShow = () => {
        setShow(true);
    }



    return (
        <div>
            <Button className="topButtons" onClick={handleShow}>
                {props.button}
              </Button>


            <Modal show={show} onHide={handleClose} 
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="my-modal"

            >
                <Modal.Header closeButton closeVariant="white" >
                    <Modal.Title>{props.header}</Modal.Title>
                </Modal.Header>
                <Modal.Body><Markup content={props.content} /></Modal.Body>
               
            </Modal>
        </div>
    );


}
